//------------------------------------------------------------------------
// Quote rotator - simple "slide show" for multiple quotes
//------------------------------------------------------------------------

"use strict";

class QuoteRotator {
  constructor(el) {
    this.el = el;

    // get all the quote rotator dots
    var dots = document.getElementsByClassName('LandingPage-quote-dot');

    for (var i = 0; i < dots.length; i++) {
        // add click event listeners to the rotator dots
        dots[i].addEventListener('click', function (evt) {
          var dot = evt.target;
          var activeDot = document.getElementsByClassName('-active-dot')[0];
          var activeQuote = document.getElementsByClassName('-active')[0];
          var quoteNum = evt.target.id.slice(-1);
          var quote = document.getElementById('quote-' + quoteNum);
          // if clicked dot is not active, remove active class from current quote
          // and add active class to clicked quote
          if (!quote.classList.contains('-active')) {
            activeDot.classList.remove('-active-dot');
            dot.className += " -active-dot";
            activeQuote.classList.remove('-active');
            quote.className += " -active";
          }
        });
    }
  }
}

// Init
$('.LandingPage-quote-rotator').each( function() {
  new QuoteRotator({ el: this });
});

export default QuoteRotator;



// WEBPACK FOOTER //
// ./scripts/components/quote_rotator.js